import CenteredSpinner from "@/components/CenteredSpinner";
import { Label } from "@/components/ui/label";
import DashboardWidgetSettings from "@/domain/entities/user/DashboardWidgetSettings";
import FeatureFlag from "@/domain/enums/FeatureFlag";
import useSetWidgetsSettings from "@/hooks/settings/useSetWidgetsSettings";
import useGetUserProfile from "@/hooks/useGetUserProfile";
import { useFeatureFlag } from "@cs_teamwaydev/mailvista-sdk_react";
import { useTranslation } from "react-i18next";
import WidgetSwitch from "./WidgetSwitch";

const Widgets = () => {
    const { t } = useTranslation();
    const { setDashboardWidgetSettings } = useSetWidgetsSettings();
    const { data: user } = useGetUserProfile();
    const isAgendaAccessEnabled = useFeatureFlag(
        FeatureFlag.AGENDA_ENABLE_ACCESS,
    );

    if (!user) {
        return <CenteredSpinner />;
    }

    const widgetParameters: DashboardWidgetSettings = {
        showRepartition:
            user.settings.displayPreferences.dashboardWidgets.showRepartition,
        showCalendar:
            user.settings.displayPreferences.dashboardWidgets.showCalendar,
        showTodo: user.settings.displayPreferences.dashboardWidgets.showTodo,
        showTipofTheDay:
            user.settings.displayPreferences.dashboardWidgets.showTipofTheDay,
    };

    const toggleWidget = async (widgetName: keyof DashboardWidgetSettings) => {
        setDashboardWidgetSettings({
            ...widgetParameters,
            [widgetName]: !widgetParameters[widgetName],
        });
    };

    const widgetIds = Object.keys(
        widgetParameters,
    ) as (keyof DashboardWidgetSettings)[];

    const widgets = widgetIds
        .filter((id) => {
            // Hide calendar widget if agenda access is disabled
            if (id === "showCalendar" && !isAgendaAccessEnabled) {
                return false;
            }

            return true;
        })
        .map((id) => ({
            id,
            isChecked: widgetParameters[id] ?? false,
            handleOnCheckedChange: () => toggleWidget(id),
            label: t(`settings.homepage.widgets.${id}`),
        }));

    return (
        <div className="flex w-full flex-col gap-2 py-2">
            <Label>{t("settings.homepage.widgets.title")}</Label>
            {widgets.map((widget) => (
                <div key={widget.id} className="flex items-center space-x-2">
                    <WidgetSwitch
                        key={widget.id}
                        handleOnCheckedChange={widget.handleOnCheckedChange}
                        id={widget.id}
                        isChecked={widget.isChecked}
                        label={widget.label}
                    />
                </div>
            ))}
        </div>
    );
};

export default Widgets;
